<template>
    <div class="page-logistics-info">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">珠海倉庫（異常件）</div>
            <div class="breadcrumb-item">物流信息</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isLoading">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <!-- 模板 -->
            <!--<div class="step-wrap">
                <div class="step-item clearfix">
                    <div class="left">
                        <div class="l-date">
                            <span>2020-08-23</span>
                            <span>周日</span>
                        </div>
                        <div class="l-time">20:30:20</div>
                    </div>
                    <div class="right">
                        <div class="r-address">快遞已簽收，簽收人：客戶，操作人：青州門店店主（聯系電話：66668888）</div>
                    </div>
                </div>

                <div class="step-item clearfix">
                    <div class="left">
                        <div class="l-date"></div>
                        <div class="l-time">15:35:30</div>
                    </div>
                    <div class="right">
                        <div class="r-address">快遞發往【青州門店】，操作人：貨車司機（聯係電話：6235478）</div>
                    </div>
                </div>

                <div class="step-item clearfix">
                    <div class="left">
                        <div class="l-date">
                            <span>2020-08-22</span>
                            <span>周六</span>
                        </div>
                        <div class="l-time">20:30:20</div>
                    </div>
                    <div class="right">
                        <div class="r-address">快遞到達【皇朝獲多利門店】，操作人：皇朝獲多利店主（聯係電話：66612345）</div>
                    </div>
                </div>

            </div>-->

            <div class="step-wrap" v-if="detail && detail.length">
                <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
                    <div class="left">
                        <div class="l-date">
                            <span>{{item.date}}</span>
                            <span>{{item.week}}</span>
                        </div>
                        <div class="l-time">{{item.time}}</div>
                    </div>
                    <div class="right">
                        <div class="r-address">{{item.describe}} , 操作人：{{item.userinfos}}</div>
                    </div>
                </div>
            </div>

            <div class="data-null" v-else>
                <img src="../../../assets/images/null-data.png" alt="" draggable="false">
                <div>暫無數據</div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                isLoading: true,
                detail: []
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
            this.getDetail();
        },
        methods: {
            getDetail()
            {
                this.isLoading = true;

                this.$Rq.requestAuth({
                    url: this.$Api.logisticsInfo + '/' + this.pageParam.orderNo,
                    method: 'get',
                    data: {}
                }).then((res) =>
                {
                    this.isLoading = false;

                    if (res.code == 0)
                    {
                        let resData = res.data;
                        let tempArr = [];

                        for (let i = 0; i < resData.length; i++)
                        {
                            let datetime = this.getDateTime(resData[i].created_at);

                            if(resData[i].describe != null){
                                tempArr.push({
                                    userinfos: resData[i].userinfos == null ? '智能櫃' : resData[i].userinfos.username,
                                    id: resData[i].id,
                                    date: datetime.date,
                                    week: datetime.week,
                                    time: datetime.time,
                                    describe: resData[i].describe
                                });
                            } else {
                                tempArr.push({
                                    userinfos: resData[i].userinfos == null ? '智能櫃' : resData[i].userinfos.username,
                                    id: resData[i].id,
                                    date: datetime.date,
                                    week: datetime.week,
                                    time: datetime.time,
                                    describe: resData[i].remarks
                                });
                            }
                        }

                        this.detail = tempArr;
                    }
                }).catch((err) =>
                {
                    this.isLoading = false;
                });
            },

            getDateTime(datetime)
            {
                let date = new Date(datetime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                let week = date.getDay();
                let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

                return {
                    date: `${this.formateNum(year)}-${this.formateNum(month)}-${this.formateNum(day)}`,
                    time: `${this.formateNum(hour)}:${this.formateNum(minute)}:${this.formateNum(second)}`,
                    week: weekList[week]
                };
            },
            formateNum(num)
            {
                return num > 9 ? num : '0' + num;
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "ExcLogisticsInfo.scss";
</style>